import { gql } from "@apollo/client";
import { SELECT_OPTION_FIELDS } from "graphql/types/SelectOptionType";

export const LIST_DSP_PRICING_SCHEME_SELECT_OPTIONS = gql`
    query DspPricingSchemeSelectOptions($businessScenario: Long!, $channelId: Long!, $isBind: Boolean!) {
        allOptions: listPricingSchemesSelectOptions(
            businessScenario: $businessScenario,
            channelId: $channelId,
            isBind: $isBind
        ) {
            ...SelectOptionFields
        }
    }
    ${SELECT_OPTION_FIELDS}
`;
